module.exports = __webpack_public_path__ + "files/7809a9536a306e2781842cf2e200555b.png";